import { createFileRoute } from '@tanstack/react-router';
import { buildDemoHead, buildNotFoundHead } from '../../../../../utils/seo';

export const Route = createFileRoute('/_layout/products/agent/demos/$slug')({
  head: ({ params }) => {
    const head = buildDemoHead(params.slug);
    if (head) return head;

    return buildNotFoundHead();
  },
});

